import React, { useEffect, useState } from 'react'
import Table from 'react-bootstrap/Table';
import { Col, Container, Row } from 'react-bootstrap'
import PrimaryGradientButton from './PrimaryGradientButton'
import { useNavigate } from 'react-router-dom';
const ThemeTable = ({data = [], navigateToOnRowClick="/", rowClickable=false, viewData=[], pickByColumn='', pickByColumnVData='', onLoadMore=()=>{}, showLodeMoreBtn=true}) => {
    const navigate = useNavigate();
    const [visibleItemCount, setVisibleItemCount] = useState(10);
    const handleShowMore = () => {
        onLoadMore()
        // setVisibleItemCount(prevCount => prevCount + 10);
    };

    const actualData = data;

    if(viewData.length > 0) {
        data = viewData;
    }

    const headers = data.length > 0 ? Object.keys(data[0]) : [];

    function onRowClick(item) {
        const columnData = item[pickByColumnVData];
        
        const selectedItem = actualData.find(i => {
            
            return i[pickByColumn] == columnData
        })
        if(rowClickable) {
            navigate(`${navigateToOnRowClick}/${columnData}`, { state: selectedItem });
        }
    }

    return (
        <>
            <Table striped bordered hover responsive>
                <thead>
                    <tr>
                    {headers.map((header, index) => (
                            <th key={index}>{header}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => {
                       const keysArray = Object.keys(item);
                        return (
                            <tr key={index} onClick={() => onRowClick(item)} className={rowClickable ? "cursor-pointer" : ""}>
                                {keysArray.map((key, index) => {
                                    return (
                                        <td key={index}>{item[key]}</td>
                                    )
                                })}

                            </tr>
                        );
                    })}
                </tbody>
            </Table>
            {/* {visibleItemCount < data.length && ( */}
               {showLodeMoreBtn && data.length > 0 && <Container>
                    <Row className='justify-content-center'>
                        <Col xs={12} lg={3}>
                            <PrimaryGradientButton onClick={handleShowMore} buttonText='Show More' />

                        </Col>
                    </Row>
                </Container>}
            {/* )} */}
        </>
    )
}
export default ThemeTable